﻿<template>
    <span class="bd-modal-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" /><path d="M12 9v4M12 17h.01" />
        </svg>
    </span>
    <h3 id="cancel-booking-title">Cancel this booking?</h3>
    <p>By clicking Cancel Booking, <strong>booking reference #{{ $store.getters.get_Booking?.group_booking_id }}</strong> will be cancelled. Cancellation fees may apply.*</p>

    <div class="bd-modal-checks">
        <label for="cancel-confirm-terms">
            <input id="cancel-confirm-terms" name="cancel-confirm-terms" type="checkbox" class="focus:ring-action h-4 w-4 text-action border-grey-light rounded">
            <span>I have explained the booking <a href="#" class="inline underline">terms and conditions</a> to the client*</span>
        </label>
        <label for="cancel-confirm-proceed">
            <input id="cancel-confirm-proceed" name="cancel-confirm-proceed" type="checkbox" class="focus:ring-action h-4 w-4 text-action border-grey-light rounded">
            <span>I wish to proceed with the cancellation of this booking*</span>
        </label>
    </div>
</template>

<script lang="ts" src="./booking_cancel.ts"></script>